// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22riI","col":"styles_col__3IkGP","actions":"styles_actions__f8NHE","conflict":"styles_conflict__3g0DJ"};